import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { MultiSelectDropDown } from '../../MultiSelectDropDown'

export const MerchForm3 = React.memo(
  ({
    dataSource: {
      id: merchandiseId,
      invoiceId,
      originCountry,
      cusCode,
      procedure,
      supplementUnits,
      additionalProceduresList,
    },
    onBlur,
    onChange,
    onSelect,
    proceduresList,
    countryList,
    addProceduresList,
    translate,
  }) => {
    const onChangeHandler = useCallback(
      ({ target: { value, name } }) => onChange(value, name),
      [merchandiseId, onChange]
    )
    const onDropDownChange = useCallback(
      (e, { value, name }) => onSelect(value, name),
      [merchandiseId, onSelect]
    )
    const onBlurHandler = useCallback(
      ({ target: { value, name } }) => onBlur(value, name),
      [merchandiseId, onBlur]
    )
    return (
      <>
        <Grid.Column>
          <DropDown
            isLabel={true}
            id={`origin-${invoiceId}-${merchandiseId}`}
            type='text'
            label="ORIGIN"
            boxNumber='5/15'
            value={originCountry}
            text={originCountry}
            data={countryList}
            clearable
            name='originCountry'
            onChange={onDropDownChange}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`cusCode-${invoiceId}-${merchandiseId}`}
            type='text'
            label="CUS_CODE"
            value={cusCode}
            name='cusCode'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>

        <Grid.Column>
          <DropDown
            isLabel={true}
            id={`procedure-${invoiceId}-${merchandiseId}`}
            type='text'
            label="PROCEDURE"
            boxNumber='1/10'
            value={procedure}
            text={procedure}
            data={proceduresList}
            direction='left'
            clearable
            name='procedure'
            onChange={onDropDownChange}
          />
        </Grid.Column>
        <Grid.Column width='4' className='multiSelect_DropDown'>
          <MultiSelectDropDown
            label='ADD_PROCEDURE'
            merchandiseId={merchandiseId}
            invoiceId={invoiceId}
            translate={translate}
            boxNumber='1/11'
            fieldType='dropdown'
            valueKey='additionalProcedure'
            dropDownData={addProceduresList}
            tableName='additionalProceduresList'
            dataList={additionalProceduresList}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            isLabel={false}
            id={`supplyUnits-${invoiceId}-${merchandiseId}`}
            type='text'
            label="SUP_UNITS"
            boxNumber='6/2'
            value={supplementUnits}
            name='supplementUnits'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
      </>
    )
  }
)

MerchForm3.defaultProps = {
  translate: (value) => value,
}